(function () {
    'use strict';

    var gettext = angular.identity;

    angular
        .module('app.accountSettings')
        .constant('accountSettings_resources', {
            saveCourseAndTeeSucceeded: gettext('Your settings have been updated.'),
            saveCourseAndTeeFailed: gettext('Failed to save settings.'),
            courseListRequestFailed: gettext('Failed to retreive courses for club.'),
        });
})();